var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInverted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 114,
    viewBox: "0 0 139 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9143 45.5684C10.2969 19.166 28.5093 0 46.2126 0C47.6346 0 49.0551 0.123769 50.4391 0.368495C51.2239 0.50633 51.9102 0.967654 52.335 1.63714C52.7583 2.31084 52.8779 3.1294 52.6627 3.89453L49.0185 16.9297C48.6669 18.1885 47.4531 19.0394 46.1915 18.9818L45.9018 18.9762C39.3364 18.9762 27.3377 28.8159 21.221 50.6851C20.9791 51.5529 20.7498 52.4404 20.529 53.3659C27.3954 49.9678 35.5867 49.1816 43.0045 51.2477C59.7387 55.9299 69.5418 73.3504 64.8639 90.0819C61.072 103.639 48.6008 113.11 34.5361 113.11C31.6711 113.11 28.8103 112.715 26.0325 111.937C14.9973 108.853 6.70053 99.6909 2.66957 86.1452C-0.968971 73.9243 -0.877556 59.1352 2.9143 45.5684Z",
    fill: "white",
    fillOpacity: 0.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.186 0C120.605 0 122.027 0.120956 123.41 0.365682C124.193 0.500704 124.881 0.964841 125.304 1.63432C125.728 2.30802 125.847 3.12659 125.633 3.89171L121.988 16.9269C121.636 18.1857 120.445 19.0366 119.161 18.979L118.874 18.9733C112.308 18.9733 100.308 28.813 94.1915 50.6823C93.9482 51.5557 93.719 52.4432 93.4995 53.363C100.369 49.965 108.557 49.1788 115.975 51.2449C132.706 55.927 142.512 73.3476 137.832 90.0791C134.04 103.636 121.569 113.107 107.504 113.107C104.639 113.107 101.778 112.712 98.9989 111.934C87.9651 108.85 79.6683 99.6881 75.6359 86.1423C71.9988 73.9215 72.0888 59.131 75.8821 45.5627C83.2689 19.1632 101.478 0 119.186 0Z",
    fill: "white",
    fillOpacity: 0.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverted);
export default __webpack_public_path__ + "static/media/inverted.e68a71f9ac7e5b6639327e9a8611a9ff.svg";
export { ForwardRef as ReactComponent };